// extracted by mini-css-extract-plugin
export default {"formControl":"Input_formControl__4wNgv","textarea":"Input_textarea__8F0OP","error":"Input_error__KUc3V"};